import { NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MetaDefinition, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthenticationService } from 'rigshare-common';
import { MetaService } from 'rigshare-common';
import { ButtonComponent } from 'rigshare-common';
import { InputComponent } from 'rigshare-common';
import { AlertComponent } from 'rigshare-common';
import { firstValueFrom } from 'rxjs';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  standalone: true,
  imports: [
    NgIf,
    AlertComponent,
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    ButtonComponent,
    RouterLink,
  ],
})
export class LoginComponent implements OnInit {
  /**
   * Create a new instance of the component.
   */
  constructor(
    private auth: AuthenticationService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    public title: Title,
    public meta: MetaService
  ) {}

  /**
   * The error message of the component.
   */
  errorMessage?: string;

  /**
   * The errors of the component.
   */
  errors: any = {};

  /**
   * The form of the component.
   */
  form: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(),
    password: new UntypedFormControl(),
  });

  /**
   * The info message of the component.
   */
  infoMessage?: string;

  /**
   * The loading state of the component.
   */
  loading = false;

  /**
   * The meta tags of the page.
   */
  public metaTags: MetaDefinition[] = [
    {
      name: "description",
      content: "Sign in to your RigShare account to start sharing music gear!",
    },
  ];

  /**
   * The success message of the component.
   */
  successMessage?: string;

  /**
   * The title tag of the page.
   */
  public titleTag = "Welcome to RigShare";

  /**
   * On component init.
   */
  ngOnInit(): void {
    this.title.setTitle(this.titleTag);
    this.meta.create(this.metaTags);

    if (this.auth.user()) {
      this.router.navigate(["/"]);
    }

    if (this.route.snapshot.queryParams["invited"]) {
      this.infoMessage = "Please sign in to accept your invitation";
    }

    if (this.route.snapshot.queryParams["auth_required"]) {
      this.infoMessage = "Please sign in to access this page";
    }
  }

  /**
   * Submit the login.
   */
  async login(): Promise<boolean> {
    await firstValueFrom(this.http.get("sanctum/csrf-cookie"));

    try {
      await this.auth.login(this.form.value);

      if (this.auth.getRedirect()) {
        await this.router.navigateByUrl(this.auth.pullRedirect());
      } else {
        await this.router.navigate(["/"]);
      }

      return true;
    } catch (res: any) {
      this.errorMessage = "The username or password you entered is incorrect";
      this.errors = res.error ? res.error.errors : null;
      return false;
    }
  }

  /**
   * Submit the login form.
   */
  async submit(): Promise<void> {
    this.loading = true;

    try {
      if (this.auth.user()) {
        this.router.navigate(["/"]);
      } else {
        await this.login();
        this.errors = {};
      }
    } finally {
      this.loading = false;
    }
  }
}
